import React, { useState, MouseEvent, FormEvent, ChangeEvent, useEffect } from 'react'
import { useHistory, useLocation } from "react-router-dom"
import Page from '../types/Page'
import Item, { ItemLevel1, ItemLevel2 } from '../types/Item'
import Level2LayoutProps from '../types/Level2LayoutProps'

interface SearchState {
  currentTab: string,
  biblioSearchTerm: string,
  bplSearchTerm: string,
  flash: string,
}

export const Search = ({ level1active, level2, handleClose, handleSearch }: Level2LayoutProps) => {
  let history = useHistory()

  const [ searchState, setSearchState ] = useState<SearchState>({ currentTab: 'bibliocommons', biblioSearchTerm: '', bplSearchTerm: '', flash: '' })

  const handleClick = (event: ChangeEvent<HTMLElement>, index: string) => {
    if (index === searchState.currentTab) { return }

    history.replace('/search')

    let nextState = { ...searchState }

    nextState.currentTab = index
    nextState.flash = ''

    setSearchState(nextState)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>, scope: string) => {
    setSearchState({
      ...searchState,
      [scope]: (event.target as HTMLInputElement).value,
    })
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>, scope: string) => {
    event.preventDefault()

    if (scope === 'bibliocommons') {
      if (searchState.biblioSearchTerm === '') {
        setSearchState({
          ...searchState,
          flash: 'Please enter a search term'
        })
        return
      }

      window.location.href = `https://burnaby.bibliocommons.com/v2/search?query=${searchState.biblioSearchTerm}&searchType=smart`
    }

    if (scope === 'pages') {
      if (searchState.bplSearchTerm === '') {
        setSearchState({
          ...searchState,
          flash: 'Please enter a search term'
        })
        return
      }
      
      setSearchState({
        ...searchState,
        flash: ''
      })
      handleSearch(searchState.bplSearchTerm.replace(/ /g, '+'))
    }
  }

  return (
    <>
      <div className={'level-2 search-bars'} id={level1active.slug}>
        {/*<div className="close-button" onClick={handleClose}>Close</div>*/}
        <div className="switchboard has-right">
          <div className="main-column">
            <h1>Search in<span className="visually-hidden"> Library Catalogue or Library Events + Services</span></h1>
            <form onSubmit={e => handleSubmit(e, searchState.currentTab)}>
              <div className="tabs">
                <div className="search-tab-group">
                    <label className={(searchState.currentTab === 'bibliocommons' ? 'tag selected' : 'tag')} htmlFor="bibliocommons">
                      Library Catalogue
                      <input 
                      type="radio" 
                      id="bibliocommons" 
                      name="bibliocommons" 
                      value="Library Catalogue"
                      checked={searchState.currentTab === "bilbiocommons"}
                      onChange={e => handleClick(e, 'bibliocommons')}
                      />
                    </label>
                    <label className={(searchState.currentTab === 'pages' ? 'tag selected' : 'tag')} htmlFor="events_services">
                      Library Events + Services
                      <input 
                        type="radio"
                        id="events_services"
                        name="events_services"
                        value="Library Events + Services"
                        checked={searchState.currentTab === "pages"}
                        onChange={e => handleClick(e, 'pages')}
                      />
                    </label>
                </div>
              </div>
              <div className="tabs-content">
                {searchState.currentTab === 'bibliocommons' && (
                  <div>
                    <div className="form-group">
                      <input aria-labelledby="search-catalogue-label" type="text" title="Type search term here" onChange={e => handleChange(e, 'biblioSearchTerm')} autoFocus />
                      <input type="submit" className="m-primary" value="Search" />
                    </div>
                  <p id="search-catalogue-label">Search the BPL Catalogue. Enter a title, subject, or name to begin.</p>
                  </div>
                )}
                {searchState.currentTab === 'pages' && (
                  <div>
                    <div className="form-group">
                      <input aria-labelledby="search-bpl-label" type="text" onChange={e => handleChange(e, 'bplSearchTerm')} autoFocus />
                      <input type="submit" className="m-primary" value="Search" />
                    </div>
                    <p id="search-bpl-label">Search BPL information, news and events.</p>
                  </div>
                )}
              </div>
            </form>
            {searchState.flash.length > 0 && (<p className="search-flash">{searchState.flash}</p>)}
          </div>
          <div className="right-column">
          {/*
            <div className="inner">
              <h1 className="more-options">More Options</h1>
              <ul>
                {level2}
              </ul>
            </div>
          */}
          </div>
        </div>
      </div>
    </>
  )
}